import { addressChannels, addressSteps } from "@/mocks/home";

export default function AddressGuide() {
  return (
    <section id="address" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
            Latest Address
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            八戒影院最新地址怎么找
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            地址会随域名调整而变化，与其记住某一串字符，不如掌握一套「怎么找、怎么验、怎么存」的方法。
            按下面四步走，基本可以在地址变动后几分钟内恢复访问。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          <div>
            <h3 className="font-heading text-lg md:text-xl text-foreground-950">获取最新地址的四个步骤</h3>
            <ol className="mt-6 space-y-4">
              {addressSteps.map((step) => (
                <li
                  key={step.no}
                  className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <span className="flex-none w-10 h-10 rounded-md bg-accent-500 text-foreground-950 font-heading flex items-center justify-center">
                    {step.no}
                  </span>
                  <div>
                    <h4 className="text-sm md:text-base font-medium text-foreground-900">
                      {step.title}
                    </h4>
                    <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">
                      {step.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div>
            <h3 className="font-heading text-lg md:text-xl text-foreground-950">常见的地址发布渠道</h3>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {addressChannels.map((channel) => (
                <article
                  key={channel.name}
                  className="p-4 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                      <i className={`${channel.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <h4 className="text-sm font-medium text-foreground-900">{channel.name}</h4>
                  </div>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-600">{channel.desc}</p>
                  <span className="mt-3 inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs">
                    {channel.note}
                  </span>
                </article>
              ))}
            </div>

            <div className="mt-4 rounded-lg overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20smartphone%20and%20a%20laptop%20on%20a%20warm%20dark%20wooden%20desk%20with%20soft%20amber%20lighting%2C%20minimal%20tech%20still%20life%2C%20subtle%20depth%20of%20field%2C%20elegant%20warm%20tones%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=bajie-address-01&orientation=landscape"
                alt="在手机与电脑上核对最新地址的场景示意图"
                title="八戒影院最新地址 获取与核对方式"
                className="w-full h-52 md:h-64 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}